import { useMutation } from "@apollo/client";

import { ObservationTypeUpdateFormInputs } from "../components/ObservationTypeUpdateForm";
import { SettingsObservationTypeEditRoute_UpdateDocument } from "../mutations.generated";

export default function useSettingsObservationTypeEditRoute_Update() {
    const [mutate, { loading, error }] = useMutation(SettingsObservationTypeEditRoute_UpdateDocument, {});

    const updateObservationType = (observationTypeId: string, input: ObservationTypeUpdateFormInputs) =>
        mutate({
            variables: { input: { ...input, observationTypeId: observationTypeId } },
        });

    return {
        updateObservationType,
        loading,
        error,
    };
}
